import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import React, {Component} from 'react';
import axios from "axios";
import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import { Button , Select, MenuItem} from "@mui/material";

export default function PrivateOfficeManagement(){
    const [categorias, setCategorias] = useState([]);
    useEffect(() => {
        getCategorias();
    })
    const getCategorias = async () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
        }).then(response=>{
          setCategorias(response.data.pilihanAlamat);
      });
        //console.log(res);
      }
    const [address1, setAddress1] = useState();
    const simpanPrivateOffice = (event) => {
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/AddPrivateOffice`, {
            simpanIni, address1
        })
    }
    const [simpanIni,setsimpanIni] = useState("");
    return <Grid>
    <Select value={address1} whiteSpace="normal" onChange={event => setAddress1(event.target.value)}>{categorias.map((categoria) =><MenuItem multiline value={categoria}>{categoria}</MenuItem>)}</Select>
    <TextField value={simpanIni} onChange={event=>setsimpanIni(event.target.value)}></TextField>
    <Button onClick={simpanPrivateOffice}>Submit</Button>
    </Grid>
}